import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import skeletonStyles from "../skeleton.module.css";
import styles from "./price.module.css";
import { Env, readFromEnv } from "@cinch-nx/environments";
export const numberWithCommas = (x)=>{
    if (typeof x === "string") {
        return Number.parseInt(x.replace(/,/g, ""), 10).toLocaleString();
    }
    return Math.round(x).toLocaleString();
};
const penceToPounds = (n)=>Math.round(n / 100);
const Price = ({ price , vehicleId , shouldShowCarsOnOfferTag =false , discountInPence , isPending , showSmallFontSize =false  })=>{
    const hasAdminFeeComplianceBeenSet = readFromEnv(Env.AdminFeeCompliance) === "true";
    const fullPrice = `£${numberWithCommas(price)}`;
    const wasPriceId = `${vehicleId}-was-price`;
    const renderCashPrice = ()=>/*#__PURE__*/ _jsx(Text, {
            element: "span",
            fontSizeFixed: "l",
            fontWeight: "semibold",
            "aria-label": `Cash price. ${fullPrice}.`,
            "aria-describedby": discountInPence ? wasPriceId : undefined,
            className: cx(styles.cashPrice, {
                [skeletonStyles.base]: isPending,
                [skeletonStyles.active]: isPending,
                [styles.cashPricePreAdminFeeCompliance]: !hasAdminFeeComplianceBeenSet
            }),
            children: fullPrice
        });
    const renderCashPriceAndWasPrice = ()=>{
        const discount = penceToPounds(discountInPence ?? 0);
        const wasPrice = `£${numberWithCommas(price + discount)}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: cx(styles.cashPrice, {
                [styles.cashPricePreAdminFeeCompliance]: !hasAdminFeeComplianceBeenSet
            }),
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    element: "span",
                    id: wasPriceId,
                    "data-testid": "was-price",
                    fontSizeFixed: "xs",
                    fontWeight: "medium",
                    "aria-hidden": true,
                    className: cx(styles.wasPrice, {
                        [skeletonStyles.base]: isPending,
                        [skeletonStyles.active]: isPending
                    }),
                    children: [
                        "Was ",
                        /*#__PURE__*/ _jsx("s", {
                            children: wasPrice
                        })
                    ]
                }),
                renderCashPrice()
            ]
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles.priceContainer, {
            [styles.smallFontSize]: showSmallFontSize
        }),
        children: shouldShowCarsOnOfferTag ? renderCashPriceAndWasPrice() : renderCashPrice()
    });
};
export default Price;
